/**
 * -------------
 * Toaster
 * -------------
 * gère l'affichage de messages pour l'utilisateur
 * usage:
 * const content = {
 *    title: titre,
 *    text: message,
 *    status: (alert | warning | valid)
 * }
 * ToasterService.showToaster(new ToastSchema(content));
 */
export default class ToasterService {

    /** identifiant du toaster */
    static toastID = 0;

    /** liste des containers créés */
    static containerList = [];

    /**
     * -----------------
     * buildToaster
     * -----------------
     * affiche un toast
     */
    static buildToaster = function (objet) {
        ToasterService.toastID++;
        let title = '';
        if (objet.content.title !== null || objet.content.subtitle !== null) {
            title = (objet.content.title !== null) ? '<strong class="toaster-content-title">' + objet.content.title + '</strong>' : '';
        }
        const icon = '<div class="toaster-content-icon"></div>';
        const text = (objet.content.text !== null) ? '<p class="toaster-content-text">' + objet.content.text + '</p>' : '';
        const close = '<div class="toaster-close"></div>';

        const toast =
            '<div class="toaster toaster-status-' + objet.content.status + '" data-toaster-close id="' + ToasterService.toastID + '">' +
                '<div class="toaster-content">' +
                    icon +
                    '<div class="toaster-content-container">' +
                        title +
                        text +
                    '</div>' +
                '</div>' +
                close +
            '</div>';
        return toast;

    }

    /**
     * -----------------
     * buildContainer
     * -----------------
     * crée un container pour les toast s'il n'existe pas déjà
     * positionne le container dans la page
     */
    static buildContainer = function (objet) {
        if (!ToasterService.containerList.includes(objet.position[0] + objet.position[1])) {
            const container =
                '<div class="toaster-container" posX="' + objet.position[0] + '" posY="' + objet.position[1] + '">' +
                '</div>';
            ToasterService.containerList.push(objet.position[0] + objet.position[1]);
            $('body').append(container);
        }
    }

    /**
     * -----------------
     * showToaster
     * -----------------
     * affiche un toast
     */
    static showToaster = function (objet) {
        const toast = ToasterService.buildToaster(objet);
        ToasterService.buildContainer(objet);

        $('.toaster-container[posX=' + objet.position[0] + '][posY=' + objet.position[1] + ']').append(toast);
        $('.toaster[id=' + ToasterService.toastID + ']').animate({
            top: "+=50",
            opacity: 1
        }, 250);

        if (objet.time > 0) {
            ToasterService.autoCloseToaster(ToasterService.toastID, objet.time);
        }
        $(document).on('click', '[data-toaster-close]', ToasterService.manualCloseToaster);
    }

    /**
     * -----------------
     * closeToaster
     * -----------------
     * ferme un toast
     */
    static autoCloseToaster = function (id, time) {
        setTimeout(function () {
            $('.toaster[id=' + id + ']').animate({
                top: "-=50",
                opacity: 0
            }, 250, function () {
                $('.toaster[id=' + id + ']').remove();
            })
        }, time);
    }

    /**
     * -----------------
     * manualCloseToaster
     * -----------------
     * ferme un toast manuellement
     */
    static manualCloseToaster = function () {
        $(this).animate({
            top: "-=50",
            opacity: 0
        }, 250, function () {
            $(this).remove();
        });
    }
}